module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/node_modules/isarray/index.js
// module id = 1153
// module chunks = 0